import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUserData } from "../../redux/emp";
import { InputOtp } from 'primereact/inputotp';
import CircularProgress from "@mui/material/CircularProgress";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import './login.css'
import { IconEye, IconEyeOff } from "@tabler/icons-react"; // Added EyeOff import
import Lottie from "lottie-react";
import hrprocess from "./hrprocess.json"

export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm();
  const [loginError, setLoginError] = useState("");
  const [forgotError, setForgotError] = useState("");
  const [showForgotForm, setShowForgotForm] = useState(false);
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [showResetPasswordForm, setShowResetPasswordForm] = useState(false);
  const [token, setToken] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [saveEmail, setSaveEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false); // NEW: Password visibility
  const [showNewPassword, setShowNewPassword] = useState(false); // NEW: For reset form
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // NEW: For reset form
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ... (Keep all your existing functions - onSubmitLogin, onSubmitForgotPassword, onSubmitOtp, onSubmitResetPassword)

  const onSubmitLogin = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/api/account/login/`,
        {
          email: data.emailLogin,
          password: data.password,
        }
      );

      if (response.status === 200) {
        const { access, refresh, user } = response.data;
        console.log("user is", user)
        localStorage.setItem("accessToken", access);
        localStorage.setItem("refreshToken", refresh);
        localStorage.setItem("userId", user.id)
        dispatch(setUserData(user));
        navigate("/user/home");
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          setError("emailLogin", { message: data.message });
          setError("password", { message: data.message });
          setLoginError(data.message);
        } else {
          setLoginError("Email or Password is not Valid. Please try again.");
        }
      } else {
        setLoginError("Network error. Please check your connection.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const onSubmitForgotPassword = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/api/account/generate_otp/`,
        {
          email: data.email,
        }
      );

      if (response.status === 200) {
        setSaveEmail(data.email);
        setShowForgotForm(false);
        setShowOtpForm(true);
        console.log("OTP has been sent to your email.", response.data);
      } else {
        setForgotError("Password reset request failed. Please try again.");
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          setForgotError(data.detail);
        } else {
          setForgotError("An unexpected error occurred. Please try again.");
        }
      } else {
        setForgotError("Network error. Please check your connection.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const onSubmitOtp = async () => {
    if (token.length === 6) {
      setIsSubmitting(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}/api/account/verify_otp/`,
          {
            otp: parseInt(token),
            email: saveEmail,
          }
        );

        console.log("OTP submitted successfully:", response.data);
        setAccessToken(response.data.access);
        setShowOtpForm(false);
        setShowResetPasswordForm(true);
      } catch (error) {
        console.error("Error submitting OTP:", error);
        setForgotError("Failed to submit OTP. Please try again.");
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setForgotError("Please enter a valid 6-digit OTP.");
    }
  };

  const onSubmitResetPassword = async (data) => {
    if (data.newPassword !== data.confirmPassword) {
      setForgotError("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/api/account/reset_password/`,
        {
          new_password: data.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      console.log("Password updated successfully:", response.data);
      setShowResetPasswordForm(false);
      setShowForgotForm(false);
      setShowOtpForm(false);
    } catch (error) {
      console.error("Error updating password:", error);
      setForgotError("Failed to update password. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
   <div className="loginContainer">
    <div style={{position:'fixed',background:'#dbaa4f',width:'100px' ,height:'100px' , bottom:0 ,filter:'blur(100px)',zIndex:'1' }}></div>
    <div style={{position:'fixed',background:'#dbaa4f',width:'100px' ,height:'100px' , top:0 ,right:0 ,filter:'blur(50px)',zIndex:'1' }}></div>
    <div className="leftside">
      {/* Logo Section */}
      <div className="logo-section">
        <img 
          src="https://prosevo.com/assets/logoprosevo.png" 
          alt="Prosevo Logo" 
        />
        <span>Prosevo</span>
      </div>

      {/* Hero Text Section */}
      <div className='empoweringContent'>
        <h1>Empowering Your</h1>
        <h1>Workday</h1>
      </div>

      {/* Lottie Animation Section */}
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Lottie 
          className="lottieAnimation"
          animationData={hrprocess} 
          loop={true}
        />
      </div>

      {/* Tagline */}
      <p className="streamlinecontent">
        Streamline HR processes with intelligent automation
      </p>
    </div>

    <div className="rightside">
      <div className="Logincontent">
        {showResetPasswordForm ? (
          <form onSubmit={handleSubmit(onSubmitResetPassword)} className="w-100">
            <h3>Set New Password</h3>
            <div style={{ position: 'relative' }}>
              <input
                type={showNewPassword ? "text" : "password"}
                className={`form-control ${errors.newPassword ? "is-invalid" : ""}`}
                placeholder="New Password"
                {...register("newPassword", { required: true })}
              />
              <span
                style={{
                  position: 'absolute', right: '15px', top: '50%',
                  transform: 'translateY(-50%)', cursor: 'pointer',
                  color: '#dbaa4f'
                }}
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? <IconEyeOff size={20} /> : <IconEye size={20} />}
              </span>
            </div>
            <div style={{ position: 'relative' }}>
              <input
                type={showConfirmPassword ? "text" : "password"}
                className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                placeholder="Confirm Password"
                {...register("confirmPassword", { required: true })}
              />
              <span
                style={{
                  position: 'absolute', right: '15px', top: '50%',
                  transform: 'translateY(-50%)', cursor: 'pointer',
                  color: '#dbaa4f'
                }}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <IconEyeOff size={20} /> : <IconEye size={20} />}
              </span>
            </div>
            <button
              className="btn w-100 text-white"
              type="submit"
              style={{ background: "#dbaa4f" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
              ) : (
                "Update Password"
              )}
            </button>
            {forgotError && <p className="error-message text-danger">{forgotError}</p>}
          </form>
        ) : showOtpForm ? (
          <div className="otp-container w-100">
            <h4>Submit your OTP</h4>
            <div className="card flex justify-content-center border-0" style={{ background: 'inherit' }}>
              <InputOtp value={token} onChange={(e) => setToken(e.value)} integerOnly length={6} />
              <button
                onClick={onSubmitOtp}
                className="btn w-100 mt-3 text-white"
                disabled={isSubmitting || token.length < 6}
                style={{ background: "#dbaa4f" }}
              >
                {isSubmitting ? (
                  <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                ) : (
                  "Submit OTP"
                )}
              </button>
            </div>
            {forgotError && <p className="error-message text-danger">{forgotError}</p>}
          </div>
        ) : showForgotForm ? (
          <form
            onSubmit={handleSubmit(onSubmitForgotPassword)}
            className="w-100"
          >
            <h4>Forgot Password</h4>
            <input
              type="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              placeholder="Enter your email"
              {...register("email", { required: true })}
            />
            <button
              className="btn w-100 text-white"
              type="submit"
              style={{ background: "#dbaa4f" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
              ) : (
                "Reset Password"
              )}
            </button>
            {forgotError && <p className="error-message text-danger">{forgotError}</p>}
          </form>
        ) : (
          <form onSubmit={handleSubmit(onSubmitLogin)} className="w-100">
            <h4>Welcome to <span style={{ fontWeight: 'bold', color: '#dbaa4f' }}>Prosevo</span></h4>
            <input
              type="email"
              className={`form-control ${errors.emailLogin ? "is-invalid" : ""}`}
              placeholder="Enter email"
              {...register("emailLogin", { required: true })}
            />
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                className={`form-control ${errors.password ? "is-invalid" : ""}`}
                placeholder="Enter password"
                {...register("password", { required: true })}
              />
              <span
                style={{
                  position: 'absolute', right: '15px', top: '50%',
                  transform: 'translateY(-50%)', cursor: 'pointer',
                  color: '#dbaa4f', zIndex: 10
                }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <IconEyeOff size={20} /> : <IconEye size={20} />}
              </span>
            </div>
            <button
              className="btn w-100 text-white"
              type="submit"
              style={{ background: "#dbaa4f" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
              ) : (
                "Login"
              )}
            </button>
            <p className="forgot-link" onClick={() => setShowForgotForm(true)}>
              Can't access your Account? <span>Forgot</span>
            </p>
            {loginError && <p className="error-message text-danger">{loginError}</p>}
          </form>
        )}
      </div>
    </div>
  </div>
  );
}